import React, { useState, forwardRef, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../orders/orders.scss";
import { components } from "react-select";
import DeleteModal from "../../components/common/DeleteModal";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import FetchData, { GetOne } from "../../providers/dataProvider";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import EnquiryNoOptionsMessage from "../../components/enquiry/EnquiryNoOptionsMessage ";
import { CheckNull, getStorageData, PriceCheck } from "../../utils/Validate";
import urls from "../../constants";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";
import { AutoSuggest } from "../../components/common/AutoSuggest";
import { useRolePermission } from "../../hooks/useRolePermission";
import validation from "./Validation";
import { CreateEntry, UpdateEntry } from "../../providers/dataProvider";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import OrderProduct from "./OrderProduct";
import { deliveryLeadTimeValues } from "../../components/common/DeliveryLeadTime";
import AttachmentUpload from "../../components/common/AttachmentUpload";
import AmountModeField from "../../components/common/AmountModeField";

// datepicker start
const ExampleCustomInput = forwardRef(
  ({ value, onClick, onChange, doc, index }, ref) => (
    <input
      value={value}
      className="example-custom-input form-control"
      onClick={onClick}
      onChange={onChange}
      ref={ref}
      placeholder="DD/MM/YYYY"
      disabled={doc?.fileName == ""}
    ></input>
  )
);
// datepicker end

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const colourOptions = [
  { value: "ocean1", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" },
];

const AddNewOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const skipAutoQuoteSelect = useRef(false);

  const { menuRights } = useRolePermission("Order");
  const [quotationId, setQuotationId] = useState(null);
  const [values, setValues] = useState({});
  const [distributertag, setDistributerTag] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [showNewProj, setShowNewProj] = useState(false);
  const [showNewCust, setShowNewCust] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [project, setProject] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [country, setCountry] = useState(null);
  const [paymentTerms, setPaymentTerms] = useState(null);
  const [orderTypeData, setOrderTypeData] = useState([{ label: "Sales Order", value: 1 }, { label: "Sample Order", value: 2 }]);
  const [paymentTermsData, setPaymentTermsData] = useState([]);
  const [deliveryTermsData, setDeliveryTermsData] = useState([]);
  const [distributor, setDistributor] = useState(null);
  const [salesEngineer, setSalesEngineer] = useState(null);
  const [allocatedToData, setAllocatedToData] = useState([]);
  const [deliveryTerms, setDeliveryTerms] = useState(null);
  const [conversionDisabled, setConversionDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [billingCustomer, setBillingCustomer] = useState("");
  const [requestDeliveryFromDate, setRDFromDate] = useState(new Date());
  const [requestDeliveryToDate, setRDToDate] = useState(new Date());
  const [advPaymentLabel, setAdvPaymentLabel] = useState(false);
  const [currencyDetail, setCurrencyDetail] = useState({})
  const [conversionRate, setConversionRate] = useState(1);
  const [deliveryLeadTime, setDeliveryLeadTime] = useState(null);
  const [transportMode, setTransportMode] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [destinationCountry, setDestinationCountry] = useState(null);
  const selectCustRef = useRef();
  const selectProjRef = useRef();
  const selectBillingCustRef = useRef();
  const submitInFlight = useRef(false);
  const [factoryOrderDate, setFactoryOrderDate] = useState(new Date());
  const [purchaseOrderDate, setPurchaseOrderDate] = useState(new Date());
  const [customerContact, setCustomerContact] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderProductTab, setOrderProductTab] = useState({});
  const [activeMainTab, setActiveMainTab] = useState("general"); // "general" | "order-summary"
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [created, setCreated] = useState(false);
  const [editOrder, setEditOrder] = useState({
    row: null,
    id: null,
  });
  const [quotUserEntry, setQuotUserEntry] = useState({});
  const [billToCheck, setBillToCheck] = useState(false)
  const [shipToCheck, setShipToCheck] = useState(false)
  const [quotationData, setQuotationData] = useState(null);
  const [editValues, setEditValues] = useState(null);
  const [prevBillingCustomerId, setPrevBillingCustomerId] = useState("");
  const [prevBillingAddress, setPrevBillingAddress] = useState("");
  const [storedAdvancePayment, setStoredAdvancePayment] = useState(0);
  const [storedPaymentPercentage, setStoredPaymentPercentage] = useState(0);

  useEffect(() => {
    const getcustomerContact = () => {
      if (customer?.customerContact) {
        const list = formatcustomerContact(customer?.customerContact);
        setCustomerContact(list);
      }
    };
    getcustomerContact();
  }, [customer?.customerContact]);

  const formatcustomerContact = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.name,
      value: data?.name
    }));
    return te;
  };

  const handleChange = (selected) => {
    setDistributerTag(selected);
  };

  const { data: pendingQuotation } = FetchData("pendingquotation");
  const { data: customerData } = FetchData("Customer");

  const customersWithPendingQuotation = React.useMemo(() => {
    if (!pendingQuotation || !customerData) return [];

    const pendingCustomerIds = new Set(
      pendingQuotation.map((item) => item?.customerId?.toLowerCase())
    );

    return customerData.filter((cust) =>
      pendingCustomerIds.has(cust?.id?.toLowerCase())
    );
  }, [pendingQuotation, customerData]);

  const filteredPendingQuotation = React.useMemo(() => {
    if (!pendingQuotation?.length || !values?.customerId) return [];

    const customerId = String(values?.customerId ?? "").toLowerCase();
    const projectId = values?.projectId
      ? String(values.projectId).toLowerCase()
      : null;

    const getRefNumber = (ref) => {
      if (!ref) return 0;
      const parts = String(ref).split("-");
      const num = parseInt(parts[parts.length - 2], 10);
      return isNaN(num) ? 0 : num;
    };

    const filtered = pendingQuotation.filter((item) => {
      const itemCustomerId = String(item?.customerId ?? "").toLowerCase();
      if (!itemCustomerId || itemCustomerId !== customerId) return false;
      if (!projectId) return true;
      return String(item?.projectId ?? "").toLowerCase() === projectId;
    });

    return filtered.sort((a, b) => {
      const dateA = a?.quotationDate || a?.createdAt || a?.createdDate;
      const dateB = b?.quotationDate || b?.createdAt || b?.createdDate;
      if (dateA && dateB) {
        return new Date(dateB) - new Date(dateA);
      }
      return getRefNumber(b?.quotationReference) - getRefNumber(a?.quotationReference); // date illana, reference number highest first
    });
  }, [pendingQuotation, values?.customerId, values?.projectId]);

  const { data: projectData } = FetchData("project");
  const { data: countryList } = FetchData("country");
  const { data: paymentTermsList } = FetchData("paymentterms");
  const { data: transportModeList } = FetchData("deliverymodes");
  const { data: deliveryTermsList } = FetchData("deliveryterms");
  const { data: distributorList } = FetchData("distributor");
  const { data: assignedEngineerList } = FetchData("userprofile");
  const { data: currencyList } = FetchData("currency");

  const defaultCurrency = React.useMemo(() => {
    return currencyList?.find(item => item?.isDefault === true);
  }, [currencyList]);

  useEffect(() => {
    setQuotationData(null);
    setQuotationId(null);
    setCustomer(null);
    setProject(null);
    setOrderType(null);
    setCountry(null);
    setPaymentTerms(null);
    setDistributor(null);
    setSalesEngineer(null);
    setDeliveryTerms(null);
    setDeliveryLeadTime(null);
    setTransportMode(null);
    setCurrency(null);
    setDestinationCountry(null);
    setQuotUserEntry({});
    setBillToCheck(false);
    setShipToCheck(false);
    setEditValues(null);
    setFactoryOrderDate(new Date());
    setPurchaseOrderDate(new Date());
    setRDFromDate(new Date());
    setRDToDate(new Date());
    setStoredAdvancePayment(0);
    setStoredPaymentPercentage(0);
    setErrors({});
    setIsSubmitting(false);

    if (!location?.state?.id) {
      setValues({});
    }
  }, [location.key]);

  useEffect(() => {
    if (location?.state?.id) {
      const item = location?.state;
      GetOne("order", { id: item?.id }, setEditValues);
    }
  }, [location?.state?.id, location.key]);

  useEffect(() => {
    if (editValues) {
      const apiData = editValues?.data || {};

      const purchaseOrderReference =
        apiData?.purchaseOrderReference ??
        apiData?.purchaseOrderRef ??
        apiData?.poReference ??
        apiData?.poReferenceNumber ??
        apiData?.poNumber ??
        apiData?.customerPoNumber ??
        "";

      const purchaseOrderDateRaw =
        apiData?.purchaseOrderDate ??
        apiData?.poDate ??
        apiData?.purchaseOrderDt ??
        null;

      const deliveryContactNo =
        apiData?.deliveryContactNo ??
        apiData?.deliveryContactNumber ??
        apiData?.deliveryPhone ??
        apiData?.deliveryPhoneNumber ??
        "";

      const advancePayment =
        apiData?.advancePayment ??
        apiData?.advancePaymentAmount ??
        0;

      const paymentPercentage =
        apiData?.paymentPercentage ??
        apiData?.advancePaymentPercentage ??
        0;

      const mergedValues = {
        ...apiData,
        purchaseOrderReference,
        deliveryContactNo,
        advancePayment,
        paymentPercentage,
      };
      if (purchaseOrderDateRaw) {
        mergedValues.purchaseOrderDate = purchaseOrderDateRaw;
      }

      setValues(mergedValues);

      setStoredAdvancePayment(advancePayment || 0);
      setStoredPaymentPercentage(paymentPercentage || 0);

      if (advancePayment > 0) {
        setAdvPaymentLabel(true);
      } else if (paymentPercentage > 0) {
        setAdvPaymentLabel(false);
      }

      if (apiData?.factoryOrderDate) {
        setFactoryOrderDate(new Date(apiData.factoryOrderDate));
      }
      if (purchaseOrderDateRaw) {
        setPurchaseOrderDate(new Date(purchaseOrderDateRaw));
      }
      if (apiData?.deliveryFromDate) {
        setRDFromDate(new Date(apiData.deliveryFromDate));
      }
      if (apiData?.deliveryToDate) {
        setRDToDate(new Date(apiData.deliveryToDate));
      }
    }
  }, [editValues])

  const HandleShowNewCustomer = () => {
    setShowNewCust(true);
  };
  const HandleShowNewProject = () => {
    setShowNewProj(true);
  };

  const NoOptionsMessage = (props) => {
    if (props?.selectProps?.name == "customer") {
      return (
        <EnquiryNoOptionsMessage
          HandleShowNew={HandleShowNewCustomer}
          selectRef={selectCustRef}
          Master="Customer Master"
          Name="customer name"
          {...props}
        />
      );
    } else if (props?.selectProps?.name == "project") {
      return (
        <EnquiryNoOptionsMessage
          HandleShowNew={HandleShowNewProject}
          selectRef={selectProjRef}
          Master="Project Master"
          Name="project name"
          {...props}
        />
      );
    }
  };

  const clearErrorField = (fieldName) => {
    setErrors((prev) => {
      if (!prev?.[fieldName]) return prev;
      const next = { ...prev };
      delete next[fieldName];
      return next;
    });
  };

  const clearErrorByInputName = (inputName) => {
    const errorKeyMap = {
      purchaseOrderReference: "poNumber",
      emailAddress: "email",
      deliveryContactNo: "deliveryContactNo",
      customerAddress: "customerAddress",
      destinationCountryId: "destinationCountry",
      destination: "destination",
      advancePayment: "advancePayment",
      paymentPercentage: "advancePayment",
      countryId: "country",
      currencyId: "currency",
      distributorId: "distributor",
      projectId: "project",
      paymentTerms: "paymentTerms",
      paymentTermId: "paymentTerms",
      deliveryTerms: "deliveryTerms",
      deliveryTermId: "deliveryTerms",
      deliveryLeadTime: "deliveryLeadTime",
      deliveryLeadTimeId: "deliveryLeadTime",
      modeOfTransport: "modeOfTransport",
      modeOfTransportId: "modeOfTransport",
      salesEngineerId: "salesEngineer",
    };

    clearErrorField(errorKeyMap[inputName] || inputName);
  };

  const prevValuesRef = useRef({});

  useEffect(() => {
    const prev = prevValuesRef.current;

    Object.keys(values).forEach((key) => {
      const oldValue = prev[key];
      const newValue = values[key];

      const becameFilled =
        (!oldValue || oldValue === "") &&
        newValue &&
        newValue !== "";

      if (becameFilled) {
        clearErrorByInputName(key);
      }
    });

    prevValuesRef.current = values;
  }, [values]);

  useEffect(() => {
    if (quotationData?.data) {
      const quotationvalues = quotationData?.data;

      const matchedCurrency = currencyList?.find(
        item => item?.id === quotationvalues?.currencyId
      );
      const rate =
        quotationvalues?.conversionRate ??
        matchedCurrency?.conversionRate ??
        1;

      setValues(prev => ({
        ...prev,
        quotationId: quotationvalues?.id,
        orderReference: quotationvalues?.quoteReference,
        orderType: quotationvalues?.quoteType,
        customerId: quotationvalues?.customerId,
        customerAddress: quotationvalues?.customerAddress,
        contactPerson: quotationvalues?.contactPerson,
        phone: quotationvalues?.phone,
        emailAddress: quotationvalues?.emailAddress,
        projectId: quotationvalues?.projectId,
        billingCustomerId: "",
        billingAddress: "",
        deliveryContactNo: "",
        countryId: quotationvalues?.countryId,
        currencyId: quotationvalues?.currencyId,
        conversionRate: rate,
        purchaseOrderReference: "",
        purchaseOrderDate: new Date(),
        distributorId: quotationvalues?.distributorId,
        salesEngineerId: quotationvalues?.salesEngineerId,
        advancePayment: quotationvalues?.advancePayment || 0,
        paymentPercentage: quotationvalues?.paymentPercentage || 0,
        paymentTermId: quotationvalues?.paymentTermId || "",
        paymentTerms: quotationvalues?.paymentTerms || "",
        creditDays: quotationvalues?.creditDays || 0,
        deliveryTermId: quotationvalues?.deliveryTermId || "",
        deliveryTerms: quotationvalues?.deliveryTerms || "",
        deliveryLeadTimeId: quotationvalues?.deliveryLeadTimeId || 0,
        deliveryLeadTime: quotationvalues?.deliveryLeadTime || "",
        modeOfTransportId: quotationvalues?.modeOfTransportId || 0,
        destinationCountryId: quotationvalues?.destinationCountryId || 0,
        destination: quotationvalues?.destination || "",
        additionalInfo: quotationvalues?.additionalInfo || "",
        otherConditions: quotationvalues?.otherConditions || "",
        deliveryFromDate: new Date(),
        deliveryToDate: new Date(),

        totalListPrice: 0,
        netPrice: 0,
        specialCharges: 0,
        totalExworksPrice: 0,
        freightCharges: quotationvalues?.freightCharges || 0,
        customDutyPercentage: quotationvalues?.customDutyPercentage || 0,
        customDuty: quotationvalues?.customDuty || 0,
        clearanceChargesPercentage: quotationvalues?.clearanceChargesPercentage || 0,
        clearanceCharges: quotationvalues?.clearanceCharges || 0,
        totalLandedCost: 0,
        salesMarginPercentage: quotationvalues?.salesMarginPercentage || 0,
        totalSellingPrice: 0,
        tax: quotationvalues?.tax || 0,
        taxPercentage: quotationvalues?.taxPercentage || 0,
        grandTotal: 0,
        sdrCharges: 0,
        discountPercentage: 0,
        discount: 0,

        cancelStatus: true,
        orderStatus: 0,
        products: [],
        attachments: []
      }));

      setConversionRate(rate);
      setStoredAdvancePayment(quotationvalues?.advancePayment || 0);
      setStoredPaymentPercentage(quotationvalues?.paymentPercentage || 0);

      if (quotationvalues?.advancePayment > 0) {
        setAdvPaymentLabel(true);
      } else if (quotationvalues?.paymentPercentage > 0) {
        setAdvPaymentLabel(false);
      }
    }
  }, [quotationData])

  useEffect(() => {
    const hasAdvancePaymentAmount = Number(values?.advancePayment) > 0;
    const hasPaymentPercentage = Number(values?.paymentPercentage) > 0;

    if (hasAdvancePaymentAmount && !hasPaymentPercentage) {
      setAdvPaymentLabel(true);
    } else if (hasPaymentPercentage && !hasAdvancePaymentAmount) {
      setAdvPaymentLabel(false);
    }
  }, [values?.advancePayment, values?.paymentPercentage]);

  // Simple params: copy selectedOption.value into one field and clear the matching error.
  const SIMPLE_FIELD_CONFIG = {
    orderType: { field: "orderType", errorField: "orderType" },
    country: { field: "countryId", errorField: "country" },
    project: { field: "projectId", errorField: "project" },
    paymentterms: { field: "paymentTermId", errorField: "paymentTerms" },
    distributor: { field: "distributorId", errorField: "distributor" },
    salesEngineer: { field: "salesEngineerId", errorField: "salesEngineer" },
    deliveryterms: { field: "deliveryTermId", errorField: "deliveryTerms" },
    destinationCountry: { field: "destinationCountryId", errorField: "destinationCountry" },
    transportmode: { field: "modeOfTransportId", errorField: "modeOfTransport" },
  };

  // Fields that get auto-filled from the selected quotation (see the quotationData effect above).
  // Cleared whenever the quote reference itself is cleared, or the customer changes.
  const QUOTATION_DEPENDENT_FIELDS = {
    quotationId: "",
    orderReference: "",
    orderType: "",
    customerAddress: "",
    contactPerson: "",
    phone: "",
    emailAddress: "",
    projectId: "",
    billingCustomerId: "",
    billingAddress: "",
    deliveryContactNo: "",
    countryId: "",
    currencyId: "",
    conversionRate: 1,
    purchaseOrderReference: "",
    distributorId: "",
    salesEngineerId: "",
    advancePayment: 0,
    paymentPercentage: 0,
    paymentTermId: "",
    paymentTerms: "",
    creditDays: 0,
    deliveryTermId: "",
    deliveryTerms: "",
    deliveryLeadTimeId: 0,
    deliveryLeadTime: "",
    modeOfTransportId: "",
    destinationCountryId: "",
    destination: "",
    additionalInfo: "",
    otherConditions: "",
    products: [],
  };

  const resetQuotationDependentSelects = () => {
    setQuotationData(null);
    setProject(null);
    setCountry(null);
    setCurrency(null);
    setDistributor(null);
    setSalesEngineer(null);
    setPaymentTerms(null);
    setDeliveryTerms(null);
    setDeliveryLeadTime(null);
    setTransportMode(null);
    setDestinationCountry(null);
    setBillingCustomer("");
    setConversionRate(1);
  };

  const HandleSelect = (selectedOption, params) => {
    switch (params) {
      case "quotationId": {
        if (!selectedOption) {
          // Quote Reference cleared -> wipe everything that came from that quotation
          setValues(prev => ({
            ...prev,
            ...QUOTATION_DEPENDENT_FIELDS,
          }));
          resetQuotationDependentSelects();
          return;
        }
        GetOne("quotation", { id: selectedOption?.value }, setQuotationData);
        clearErrorField("quoteRef");
        return;
      }

      case "customer": {
        if (!selectedOption) {
          // Customer cleared -> same reset as quote ref, plus customerId itself
          setValues(prev => ({
            ...prev,
            customerId: "",
            ...QUOTATION_DEPENDENT_FIELDS,
          }));
          setQuotationId(null);
          resetQuotationDependentSelects();
          return;
        }
        setValues(prev => ({
          ...prev,
          customerId: selectedOption?.value,
          quotationId: "",
        }));
        setQuotationId(null);
        clearErrorField("customer");
        return;
      }

      case "project": {
        skipAutoQuoteSelect.current = true;

        if (!selectedOption) {
          setValues(prev => ({
            ...prev,
            ...QUOTATION_DEPENDENT_FIELDS,
          }));
          setQuotationId(null);
          resetQuotationDependentSelects();
          clearErrorField("project");
          return;
        }

        setValues(prev => ({
          ...prev,
          ...QUOTATION_DEPENDENT_FIELDS,
          projectId: selectedOption?.value,
        }));
        setQuotationId(null);
        resetQuotationDependentSelects();
        clearErrorField("project");
        return;
      }

      case "currency": {
        const matchedCurrency = currencyList?.find(
          item => item?.id === selectedOption?.value
        );
        const rate = matchedCurrency?.conversionRate || 1;
        setValues(prev => ({
          ...prev,
          currencyId: selectedOption?.value,
          conversionRate: rate,
        }));
        setConversionRate(rate);
        clearErrorField("currency");
        return;
      }

      case "deliveryLeadTime": {
        setValues(prev => ({
          ...prev,
          deliveryLeadTimeId: selectedOption?.value,
          deliveryLeadTime: selectedOption?.value === 0 ? "" : selectedOption?.label,
        }));
        clearErrorField("deliveryLeadTime");
        return;
      }

      case "billingCustomer": {
        setValues(prev => ({
          ...prev,
          billingCustomerId: selectedOption?.value,
          billingAddress: selectedOption?.address || "",
          deliveryContactNo: selectedOption?.phone || "",
        }));
        clearErrorField("billingCustomer");
        clearErrorField("billingAddress");
        return;
      }

      default: {
        const config = SIMPLE_FIELD_CONFIG[params];
        if (!config) return;
        setValues(prev => ({
          ...prev,
          [config.field]: selectedOption?.value,
        }));
        clearErrorField(config.errorField);
      }
    }
  };

  useEffect(() => {
    setValues(prevValues => ({
      ...prevValues,
      factoryOrderDate: factoryOrderDate,
      purchaseOrderDate: purchaseOrderDate,
      deliveryFromDate: requestDeliveryFromDate,
      deliveryToDate: requestDeliveryToDate
    }));
  }, [purchaseOrderDate, factoryOrderDate, requestDeliveryFromDate, requestDeliveryToDate])

  const HandleFormChange = (e) => {
    const { name, value } = e.target;
    if (e.target.type == "checkbox") {
      const isChecked = e.target.checked;
      setAdvPaymentLabel(isChecked);

      if (isChecked) {
        setStoredPaymentPercentage(values?.paymentPercentage || 0);
        setValues(prev => ({
          ...prev,
          advancePayment: storedAdvancePayment || prev?.advancePayment || 0,
          paymentPercentage: 0,
        }));
      } else {
        setStoredAdvancePayment(values?.advancePayment || 0);
        setValues(prev => ({
          ...prev,
          advancePayment: 0,
          paymentPercentage: storedPaymentPercentage || prev?.paymentPercentage || 0,
        }));
      }
    } else {
      setValues(prev => ({
        ...prev,
        [name]: value,
      }));
      clearErrorByInputName(name);
      if (name === "advancePayment") {
        setStoredAdvancePayment(value);
      } else if (name === "paymentPercentage") {
        setStoredPaymentPercentage(value);
      }
    }
  };

  useEffect(() => {
    const obj = paymentTermsList?.find(
      (item) => item?.id == paymentTerms?.value
    );

    setValues(prevValues => ({
      ...prevValues,
      creditDays: obj?.creditDays || ""
    }));
  }, [paymentTerms]);

  useEffect(() => {
    setDeliveryTermsData([
      ...deliveryTermsList,
      { deliveryDescription: "Others", id: "0" },
    ]);
  }, [deliveryTermsList]);

  useEffect(() => {
    if (distributorList?.find(item => item?.id === values?.distributorId)?.defaultCompanyDistributor === true) {
      setDeliveryTermsData([
        ...deliveryTermsList,
        { deliveryDescription: "Others", id: "0" },
      ]);
      setPaymentTermsData(paymentTermsList)
    }
    else {
      const deliveryTerm = distributorList?.find(item => item?.id === values?.distributorId)?.distributorDeliveryTerms
      const filterDeliverTerm = deliveryTermsList.filter(item1 => deliveryTerm?.some(item2 => item1.id === item2.deliveryTermId));

      const paymentTerm = distributorList?.find(item => item?.id === values?.distributorId)?.distributorPaymentTerms
      const filterPaymentTerm = paymentTermsList.filter(item1 => paymentTerm?.some(item2 => item1.id === item2.paymentTermId));
      setDeliveryTermsData([
        ...filterDeliverTerm,
        { deliveryDescription: "Others", id: "0" },
      ]);
      setPaymentTermsData(filterPaymentTerm)
    }
  }, [values?.distributorId, deliveryTermsList, paymentTermsList, distributorList])

  useEffect(() => {
    if (distributor?.defaultCompanyDistributor === true) {
      setAllocatedToData(assignedEngineerList?.filter(item => (item?.isActive === true || item?.identityId === values?.salesEngineerId)))
    }
    else {
      setAllocatedToData(assignedEngineerList?.filter(item => item?.userCompanyId === values?.distributorId && (item?.isActive === true || item?.identityId === values?.salesEngineerId)))
    }
  }, [distributor, assignedEngineerList])


  useEffect(() => {
    if (location?.state?.id || CheckNull(values?.id) !== "") return;

    const userProf = getStorageData();
    const userProfId = userProf?.userCompanyId;
    if (userProf?.userType === 2) {
      setValues(prevValues => ({
        ...prevValues,
        distributorId: userProfId,
        countryId: distributorList?.find(item => item?.id === userProfId)?.countryId,
        currencyId: distributorList?.find(item => item?.id === userProfId)?.currencyId,
        conversionRate: distributorList?.find(item => item?.id === userProfId)?.conversionRate,
      }))
      const isQAR = currencyList?.some(item => item?.id === distributorList?.find(item => item?.id === userProfId)?.currencyId && item?.shortCode === "QAR");
      setConversionDisabled(isQAR);
    }
  }, [distributorList, currencyList, location?.state?.id, values?.id])

  const handleSubmit = () => {
    if (submitInFlight.current || loading) return;

    const validationErrors = validation(values, salesEngineer, advPaymentLabel);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length !== 0) {
      return;
    }

    submitInFlight.current = true;
    setLoading(true);

    const cleanedAttachments = (values?.attachments || [])
      .filter(a => a.attachmentUrl)
      .map(a => ({
        id: a.id || 0,
        orderId: values?.id || "",
        attachmentTypeId: a.attachmentTypeId,
        attachmentName: a.attachmentName,
        attachmentUrl: a.attachmentUrl,
      }));

    if (CheckNull(values?.id) !== "") {
      const updatedObj = {
        ...values,
        attachments: cleanedAttachments,
        modifiedAt: new Date(),
        modifiedBy: localStorage.getItem("authidentity"),
      };
      UpdateEntry(
        "order",
        updatedObj,
        setCreateMsg,
        "Order updated successfully",
        "Failed to update order"
      );
    } else {
      const updatedObj = {
        ...values,
        attachments: cleanedAttachments,
        orderReference: "OR0001",
        createdAt: new Date(),
        createdBy: localStorage.getItem("authidentity"),
      };
      CreateEntry(
        "order",
        updatedObj,
        setCreateMsg,
        "Order created successfully",
        "Failed to create order"
      );
    }
  };

  const HandleOrderSummaryTabClick = (e) => {
    e.preventDefault();
    const validationErrors = validation(values, salesEngineer, advPaymentLabel);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length !== 0) {
      e.stopPropagation();
      return;
    }
    setActiveMainTab("order-summary");
  };

  useEffect(() => {
    if (!createMsg) return;

    const isFailure =
      Number(createMsg?.status) >= 400 ||
      CheckNull(createMsg?.message).includes("Failed");

    if (isFailure) {
      const raw = createMsg?.successData;
      const errorsmsg = raw?.errors?.length
        ? raw
        : { errors: [{ message: createMsg?.message || "Something went wrong" }] };
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
      setLoading(false);
      submitInFlight.current = false;
    } else if (
      CheckNull(createMsg?.message) == "Order created successfully"
    ) {
      const dt = createMsg?.successData;
      if (dt?.id) {
        setValues((prev) => ({ ...prev, id: dt.id }));
      }
      setShow(true);
      setCreated(false);
      setLoading(false);
      submitInFlight.current = false;
    } else if (
      CheckNull(createMsg?.message) == "Order updated successfully"
    ) {
      if (values?.id) {
        GetOne("order", { id: values.id }, (res) => {
          const freshAttachments = res?.data?.attachments || [];
          setValues((prev) => ({ ...prev, attachments: freshAttachments }));
        });
      }
      setShow(true);
      setCreated(false);
      setLoading(false);
      submitInFlight.current = false;
    }
  }, [createMsg]);

  const SuccessDoneClick = () => {
    setShow(false);
    if (created) {
      setShowNewProj(false);
      setShowNewCust(false);
      return;
    }
  };

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  useEffect(() => {
    const currency = currencyList?.find(
      item => item?.id === values?.currencyId
    );
    setCurrencyDetail(
      currency
        ? { ...currency, conversionRate: values?.conversionRate ?? currency?.conversionRate }
        : currency
    );
  }, [values?.currencyId, currencyList, values?.conversionRate]);

  const HandleBillTo = (e) => {
    const isChecked = e.target.checked;
    setBillToCheck(isChecked);

    if (isChecked) {
      setPrevBillingCustomerId(values?.billingCustomerId || "");
      setValues(prev => ({
        ...prev,
        billingCustomerId: values?.customerId,
      }));
      clearErrorField("billingCustomer");
    } else {
      setValues(prev => ({
        ...prev,
        billingCustomerId: prevBillingCustomerId,
      }));
    }
  };

  const HandleShipTo = (e) => {
    const isChecked = e.target.checked;
    setShipToCheck(isChecked);
    if (isChecked) {
      setPrevBillingAddress(values?.billingAddress || "");
      setValues(prev => ({
        ...prev,
        billingAddress: values?.customerAddress,
      }));
      clearErrorField("billingAddress");
    } else {
      setValues(prev => ({
        ...prev,
        billingAddress: prevBillingAddress,
      }));
    }
  };

  const CloseOthersOption = (fieldName) => {
    if (fieldName === "deliveryTerms") {
      setDeliveryTerms(null);
      setValues(prev => ({
        ...prev,
        deliveryTermId: "",
        deliveryTerms: ""
      }));
      clearErrorField("deliveryTerms");
    } else if (fieldName === "deliveryLeadTime") {
      setDeliveryLeadTime(null);
      setValues(prev => ({
        ...prev,
        deliveryLeadTimeId: 0,
        deliveryLeadTime: ""
      }));
      clearErrorField("deliveryLeadTime");
    }
  };


  useEffect(() => {
    setDeliveryLeadTime(
      deliveryLeadTimeValues?.find(
        (item) => Number(item?.value) === values?.deliveryLeadTimeId
      )
    );
  }, [deliveryLeadTimeValues, values?.deliveryLeadTimeId]);

  const handleCancel = () => {
    setValues({});
    navigate("/order-list");
  }

  useEffect(() => {
    if (location?.state?.id || values?.id) return;

    if (skipAutoQuoteSelect.current) {
      skipAutoQuoteSelect.current = false;
      return;
    }

    if (filteredPendingQuotation?.length === 1) {
      const singleQuote = filteredPendingQuotation[0];
      setQuotationId({
        label: singleQuote?.quotationReference,
        value: singleQuote?.quotationId,
      });
      HandleSelect(
        { value: singleQuote?.quotationId },
        "quotationId"
      );
    }
  }, [filteredPendingQuotation, location?.state?.id, values?.id]);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          title: values?.id
            ? `Order : ${values?.orderReference}`
            : "New Order",
          backTarget: {
            pathname: "/order-list",
          },
        },
      })
    );

    return () => {
      window.dispatchEvent(
        new CustomEvent("pathfinderHeaderMetaChange", {
          detail: {
            pathname: location.pathname,
            clear: true,
          },
        })
      );
    };
  }, [
    location.pathname,
    values?.id,
    values?.orderReference,
  ]);

  return (
    <div className="container-fluid">
      <section id="addNewOrderSec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 my-auto">
            <div className="card">
              {orderProductTab?.tab !== "editorderquantity" && (
                <div className="card-header">

                  <div className="d-flex justify-content-start">
                    <div
                      className="nav nav-pills order-tabs"
                      id="pills-tab"
                      role="tablist"
                    >
                      <a
                        className={`nav-link${activeMainTab === "general" ? " active" : ""}`}
                        id="pills-general-tab"
                        href="#pills-general"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveMainTab("general");
                        }}
                      >
                        <i className="far fa-file-alt mr-2"></i>
                        General
                      </a>

                      <a
                        className={`nav-link${activeMainTab === "order-summary" ? " active" : ""}`}
                        id="pills-order-summary-tab"
                        href="#pills-order-summary"
                        role="tab"
                        onClick={HandleOrderSummaryTabClick}
                      >
                        <i className="fas fa-boxes mr-2"></i>
                        Order Summary
                      </a>
                    </div>
                  </div>

                </div>
              )}
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className={`tab-pane fade${activeMainTab === "general" ? " show active" : ""}`}
                        id="pills-general"
                        role="tabpanel"
                        aria-labelledby="pills-general-tab"
                      >
                        <div className="row">
                          <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 left-col">
                            <div className="card">
                              <div className="card-header">
                                <h2>Customer & Contact</h2>
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Customer Name{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        placeHolder={PlaceHolder?.SELECT_CUSTOMER}
                                        pageName="order"
                                        dpDownName="customer"
                                        stateData={customersWithPendingQuotation}
                                        controlName="customer"
                                        handleChange={(e) => {
                                          HandleSelect(e, "customer");
                                        }}
                                        value={customer}
                                        valueId={values?.customerId}
                                        setState={setCustomer}
                                        multiSelect={false}
                                        components={{ NoOptionsMessage }}
                                        refComp={selectCustRef}
                                        isDisabled={values?.id ? true : false}
                                      />
                                      {errors.customer && (
                                        <p className="form-error">{errors.customer}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Quote Reference{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        key={`quotationId-${values?.customerId}-${values?.projectId}`}
                                        isDisabled={values?.id ? true : !values?.customerId}
                                        placeHolder={
                                          !values?.customerId
                                            ? PlaceHolder?.MUST_CHOOSE_FIELD("customer", "quote reference")
                                            : PlaceHolder?.SELECT_QUOTE_REF
                                        }
                                        pageName="order"
                                        dpDownName="quotationId"
                                        stateData={filteredPendingQuotation}
                                        controlName="quotationId"
                                        handleChange={(e) => { HandleSelect(e, "quotationId"); }}
                                        value={quotationId}
                                        valueId={values?.quotationId}
                                        setState={setQuotationId}
                                        multiSelect={false}
                                      />
                                      {errors.quoteRef && (
                                        <p className="form-error">{errors.quoteRef}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Factory Order Date{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DatePicker
                                        selected={factoryOrderDate}
                                        onChange={(date) => setFactoryOrderDate(date)}
                                        customInput={<ExampleCustomInput />}
                                        dayClassName={() => "example-datepicker-day-class"}
                                        popperClassName="example-datepicker-class"
                                        todayButton="TODAY"
                                        dateFormat="dd/MM/yyyy"
                                        minDate={new Date()}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <div>
                                        <label>Customer PO Date</label>
                                      </div>
                                      <div>
                                        <DatePicker
                                          selected={purchaseOrderDate}
                                          onChange={(date) => setPurchaseOrderDate(date)}
                                          customInput={<ExampleCustomInput />}
                                          dayClassName={() => "example-datepicker-day-class"}
                                          popperClassName="example-datepicker-class"
                                          todayButton="TODAY"
                                          dateFormat="dd/MM/yyyy"
                                          minDate={new Date()}
                                        />
                                        {errors.poDate && (
                                          <p className="form-error">{errors.poDate}</p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Customer PO Number{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter customer PO number"
                                        name="purchaseOrderReference"
                                        value={values?.purchaseOrderReference}
                                        onChange={HandleFormChange}
                                      ></input>
                                      {errors.poNumber && (
                                        <p className="form-error">{errors.poNumber}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Customer Address{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <textarea
                                        className="form-control customer-address-textarea"
                                        placeholder="Enter your address"
                                        rows="5"
                                        name="customerAddress"
                                        value={values?.customerAddress}
                                        onChange={HandleFormChange}
                                      ></textarea>
                                      {errors.customerAddress && (
                                        <p className="form-error">{errors.customerAddress}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Currency <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        //  isDisabled={distributor?.defaultCompanyDistributor === true ? false : true}
                                        placeHolder={PlaceHolder.SELECT_CURRENCY}
                                        pageName="order"
                                        dpDownName="currencyCode"
                                        stateData={currencyList}
                                        controlName="currency"
                                        handleChange={(e) => {
                                          HandleSelect(e, "currency");
                                        }}
                                        value={currency}
                                        valueId={values?.currencyId}
                                        setState={setCurrency}
                                        multiSelect={false}
                                      />
                                      {errors.currency && (
                                        <p className="form-error">{errors.currency}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Conversion rate{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          class="form-control"
                                          placeholder="Enter currency exchange"
                                          name="conversionRate"
                                          onChange={HandleFormChange}
                                          value={values?.conversionRate || ""}
                                          disabled={conversionDisabled}
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          1 {defaultCurrency?.shortCode || "QAR"}
                                        </span>
                                        {errors.conversionRate && (
                                          <p className="form-error">{errors.conversionRate}</p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Phone Number{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <PhoneNumberComponent defaultCountry={country?.code} errors={errors} setValues={setValues} setErrors={setErrors} filedName="phone" values={values} />
                                      {errors.phone && (
                                        <p className="form-error">{errors.phone}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>Email Address</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Email address"
                                        name="emailAddress"
                                        value={values?.emailAddress}
                                        onChange={HandleFormChange}
                                      ></input>
                                      {errors.email && (
                                        <p className="form-error">{errors.email}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Country <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        isDisabled={false}
                                        placeHolder={PlaceHolder.SELECT_COUNTRY}
                                        pageName="order"
                                        dpDownName="country"
                                        stateData={countryList}
                                        controlName="country"
                                        handleChange={(e) => {
                                          HandleSelect(e, "country");
                                        }}
                                        value={country}
                                        valueId={values?.countryId}
                                        setState={setCountry}
                                        multiSelect={false}
                                      />
                                      {errors.country && (
                                        <p className="form-error">{errors.country}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>Distributor</label>
                                      <DropDownComponent
                                        placeHolder={PlaceHolder.SELECT_DISTRIBUTOR}
                                        pageName="order"
                                        dpDownName="distributor"
                                        stateData={distributorList}
                                        controlName="distributor"
                                        handleChange={(e) => {
                                          HandleSelect(e, "distributor");
                                        }}
                                        value={distributor}
                                        valueId={values?.distributorId?.toLowerCase()}
                                        setState={setDistributor}
                                        multiSelect={false}
                                        isDisabled={
                                          values?.id
                                            ? true
                                            : getStorageData()?.userType === 2 ? true
                                              : false
                                        }
                                      />
                                      {errors.distributor && (
                                        <p className="form-error">{errors.distributor}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Sales Engineer{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        isDisabled={(values?.customerId && getStorageData()?.roleId === urls?.ADMIN_ROLE_ID) ? false : true}
                                        placeHolder={values?.customerId ? PlaceHolder?.SELECT_SALES_ENGINEER : PlaceHolder?.MUST_CHOOSE_FIELD("customer", "sales engineer")}
                                        pageName="order"
                                        dpDownName="allocatedTo"
                                        stateData={allocatedToData}
                                        controlName="assignedInqEngineer"
                                        handleChange={(e) => {
                                          HandleSelect(e, "salesEngineer");
                                        }}
                                        value={salesEngineer}
                                        valueId={values?.salesEngineerId?.toLowerCase()}
                                        setState={setSalesEngineer}
                                        multiSelect={false}
                                      />
                                      {errors.salesEngineer && (
                                        <p className="form-error">{errors.salesEngineer}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>Other details</label>
                                      <textarea
                                        className="form-control other-details-textarea"
                                        placeholder="Enter your notes here"
                                        rows="5"
                                        name="otherConditions"
                                        value={values?.otherConditions}
                                        onChange={HandleFormChange}
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 right-col">
                            <div className="card">
                              <div className="card-header">
                                <h2>Project & Commercial Terms</h2>
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Project Name{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        placeHolder={PlaceHolder?.SELECT_PROJECT}
                                        pageName="order"
                                        dpDownName="project"
                                        stateData={projectData}
                                        controlName="project"
                                        handleChange={(e) => {
                                          HandleSelect(e, "project");
                                        }}
                                        value={project}
                                        valueId={values?.projectId}
                                        setState={setProject}
                                        multiSelect={false}
                                        refComp={selectProjRef}
                                        components={{ NoOptionsMessage }}
                                        isDisabled={values?.id ? true : false}
                                      />
                                      {errors.project && (
                                        <p className="form-error">{errors.project}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Cusotmer Order Type <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        placeHolder={PlaceHolder?.SELECT_PROJECT}
                                        pageName="order"
                                        dpDownName="orderType"
                                        stateData={orderTypeData}
                                        controlName="orderType"
                                        handleChange={(e) => {
                                          HandleSelect(e, "orderType");
                                        }}
                                        value={orderType}
                                        valueId={values?.orderType}
                                        setState={setOrderType}
                                        multiSelect={false}
                                        isDisabled={false}
                                      />
                                      {errors.orderType && (
                                        <p className="form-error">{errors.orderType}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <div className="bill-to-label">
                                        <div>
                                          <label>
                                            Bill To <span className="mandatory">*</span>
                                          </label>
                                        </div>
                                        <div class="form-group">
                                          <input
                                            type="checkbox"
                                            id="billToName"
                                            name="billToName"
                                            onChange={HandleBillTo}
                                            value={billToCheck}
                                          />
                                          <label for="billToName">
                                            Customer Name same as Bill To
                                          </label>
                                        </div>
                                      </div>
                                      <DropDownComponent
                                        placeHolder={PlaceHolder?.SELECT_CUSTOMER}
                                        pageName="order"
                                        dpDownName="customer"
                                        stateData={customerData}
                                        controlName="customer"
                                        handleChange={(e) => {
                                          HandleSelect(e, "billingCustomer");
                                        }}
                                        value={billingCustomer}
                                        valueId={values?.billingCustomerId}
                                        setState={setBillingCustomer}
                                        multiSelect={false}
                                        components={{ NoOptionsMessage }}
                                        refComp={selectBillingCustRef}
                                        isDisabled={false}
                                      />
                                      {errors.billingCustomer && (
                                        <p className="form-error">{errors.billingCustomer}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <div className="ship-to-label">
                                        <div>
                                          <label>
                                            Ship To <span className="mandatory">*</span>
                                          </label>
                                        </div>

                                        <div class="form-group">
                                          <input
                                            type="checkbox"
                                            id="billToAddress"
                                            name="billToAddress"
                                            onChange={HandleShipTo}
                                            value={shipToCheck}
                                          />
                                          <label for="billToAddress">
                                            Customer Address same as Delivery Address
                                          </label>
                                        </div>
                                      </div>
                                      <textarea
                                        className="form-control delivery-address-textarea"
                                        placeholder="Enter delivery address"
                                        rows="5"
                                        name="billingAddress"
                                        value={values?.billingAddress}
                                        onChange={HandleFormChange}
                                      ></textarea>
                                      {errors.billingAddress && (
                                        <p className="form-error">{errors.billingAddress}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Contact Person{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <AutoSuggest
                                        className="form-control"
                                        options={customerContact}
                                        setStateValue={setValues}
                                        stateValue={values}
                                        placeholder="Enter name"
                                        params="contactPerson"
                                      />
                                      {errors.contactPerson && (
                                        <p className="form-error">{errors.contactPerson}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Delivery Contact Number{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <PhoneNumberComponent
                                        defaultCountry={country?.code}
                                        errors={errors}
                                        setValues={setValues}
                                        setErrors={setErrors}
                                        filedName="deliveryContactNo"
                                        values={values}
                                      />
                                      {errors.deliveryContactNo && (
                                        <p className="form-error">{errors.deliveryContactNo}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Payment Terms{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        isDisabled={false}
                                        placeHolder={PlaceHolder.SELECT_PAYMENT_TERMS}
                                        pageName="order"
                                        dpDownName="paymentterms"
                                        stateData={paymentTermsList}
                                        controlName="paymentterms"
                                        handleChange={(e) => {
                                          HandleSelect(e, "paymentterms");
                                        }}
                                        value={paymentTerms}
                                        valueId={values?.paymentTermId?.toLowerCase()}
                                        setState={setPaymentTerms}
                                        multiSelect={false}
                                      />
                                      {errors.paymentTerms && (
                                        <p className="form-error">{errors.paymentTerms}</p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Advance Payment
                                      </label>
                                      <AmountModeField
                                        id="customer-order-advance-payment"
                                        mode={advPaymentLabel ? "$" : "%"}
                                        name={advPaymentLabel ? "advancePayment" : "paymentPercentage"}
                                        onChange={HandleFormChange}
                                        onModeToggle={() => {
                                          HandleFormChange({
                                            target: {
                                              name: "advance_mode",
                                              type: "checkbox",
                                              checked: !advPaymentLabel,
                                            },
                                          });
                                        }}
                                        placeholder="Enter advance payment"
                                        type="text"
                                        value={
                                          advPaymentLabel
                                            ? values?.advancePayment > 0
                                              ? values?.advancePayment
                                              : ""
                                            : values?.paymentPercentage > 0
                                              ? values?.paymentPercentage
                                              : ""
                                        }
                                      />

                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Credit Days <span className="mandatory">*</span>
                                      </label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Choose days"
                                        name="creditDays"
                                        value={values?.creditDays}
                                        disabled={true}
                                      ></input>
                                    </div>
                                  </div>
                                  {deliveryTerms?.label != "Others" && (
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                      <div>
                                        <label>
                                          Delivery Terms{" "}
                                          <span className="mandatory">*</span>
                                        </label>
                                        <DropDownComponent
                                          isDisabled={false}
                                          placeHolder={PlaceHolder.SELECT_DELIVERY_TERMS}
                                          pageName="order"
                                          dpDownName="deliveryterms"
                                          stateData={deliveryTermsList}
                                          controlName="deliveryterms"
                                          handleChange={(e) => {
                                            HandleSelect(e, "deliveryterms");
                                          }}
                                          value={deliveryTerms}
                                          valueId={values?.deliveryTermId}
                                          setState={setDeliveryTerms}
                                          multiSelect={false}
                                        />
                                        {errors.deliveryTerms && (
                                          <p className="form-error">{errors.deliveryTerms}</p>
                                        )}
                                      </div>
                                    </div>)}
                                  {deliveryTerms?.label == "Others" && (
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                      <div>
                                        <label>Delivery Terms</label>
                                        <div className="input-group">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Enter others"
                                            name="deliveryTerms"
                                            onChange={HandleFormChange}
                                            value={values?.deliveryTerms}
                                          ></input>
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            onClick={() => CloseOthersOption("deliveryTerms")}
                                          >
                                            <i className="fas fa-times"></i>
                                          </span>
                                        </div>
                                        {errors.deliveryTerms && (
                                          <p className="form-error">{errors.deliveryTerms}</p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {deliveryLeadTime?.label != "Others" && (
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                      <div>
                                        <label>
                                          Delivery Lead Time{" "}
                                          <span className="mandatory">*</span>
                                        </label>
                                        <DropDownComponent
                                          isDisabled={false}
                                          placeHolder={PlaceHolder.SELECT_DELIVERY_LEAD_TIME}
                                          pageName="order"
                                          dpDownName="status"
                                          stateData={deliveryLeadTimeValues}
                                          controlName="deliveryLeadTime"
                                          handleChange={(e) => {
                                            HandleSelect(e, "deliveryLeadTime");
                                          }}
                                          value={deliveryLeadTime}
                                          valueId={values?.deliveryLeadTimeId}
                                          setState={setDeliveryLeadTime}
                                          multiSelect={false}
                                        />
                                        {errors.deliveryLeadTime && (
                                          <p className="form-error">{errors.deliveryLeadTime}</p>
                                        )}
                                      </div>
                                    </div>)}
                                  {deliveryLeadTime?.label == "Others" && (
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                      <div>
                                        <label>Delivery Lead Time</label>
                                        <div className="input-group">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Enter others"
                                            name="deliveryLeadTime"
                                            onChange={HandleFormChange}
                                            value={values?.deliveryLeadTime || ""}
                                            valueId={values?.deliveryLeadTimeId}
                                          ></input>
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            onClick={() => CloseOthersOption("deliveryLeadTime")}
                                          >
                                            <i className="fas fa-times"></i>
                                          </span>
                                        </div>
                                        {errors.deliveryLeadTime && (
                                          <p className="form-error">{errors.deliveryLeadTime}</p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Mode of Transport{" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DropDownComponent
                                        isDisabled={false}
                                        placeHolder={PlaceHolder.SELECT_TRANSPORT_MODE}
                                        pageName="jobinhand"
                                        dpDownName="transportmode"
                                        stateData={transportModeList}
                                        controlName="transportmode"
                                        handleChange={(e) => {
                                          HandleSelect(e, "transportmode");
                                        }}
                                        value={transportMode}
                                        valueId={values?.modeOfTransportId}
                                        setState={setTransportMode}
                                        multiSelect={false}
                                      />
                                      {errors.modeOfTransport && (
                                        <p className="form-error">{errors.modeOfTransport}</p>
                                      )}
                                    </div>
                                  </div>
                                  {(deliveryTerms?.countryRequired ||
                                    deliveryTerms?.label == "Others") && (
                                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                        <div>
                                          <label>Destination Country</label>
                                          <DropDownComponent
                                            isDisabled={false}
                                            placeHolder={PlaceHolder.SELECT_COUNTRY}
                                            pageName="order"
                                            dpDownName="country"
                                            stateData={countryList}
                                            controlName="destinationCountry"
                                            handleChange={(e) => {
                                              HandleSelect(e, "destinationCountry");
                                            }}
                                            value={destinationCountry}
                                            valueId={values?.destinationCountryId}
                                            setState={setDestinationCountry}
                                            multiSelect={false}
                                          />
                                          {errors.destinationCountry && (
                                            <p className="form-error">{errors.destinationCountry}</p>
                                          )}
                                        </div>

                                      </div>
                                    )}
                                  {(deliveryTerms?.destinationRequired ||
                                    deliveryTerms?.value == "Others") && (
                                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                        <div>
                                          <label>Destination</label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Enter destination"
                                            name="destination"
                                            onChange={HandleFormChange}
                                            value={values?.destination}
                                          ></input>
                                          {errors.destination && (
                                            <p className="form-error">{errors.destination}</p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Request Delivery Date (From){" "}
                                        <span className="mandatory">*</span>
                                      </label>
                                      <DatePicker
                                        selected={requestDeliveryFromDate}
                                        onChange={(date) => setRDFromDate(date)}
                                        customInput={<ExampleCustomInput />}
                                        dayClassName={() =>
                                          "example-datepicker-day-class"
                                        }
                                        popperClassName="example-datepicker-class"
                                        todayButton="TODAY"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                    <div>
                                      <label>
                                        Request Delivery Date (To){" "}
                                        <span className="mandatory">*</span>
                                      </label>

                                      <DatePicker
                                        selected={requestDeliveryToDate}
                                        onChange={(date) => setRDToDate(date)}
                                        customInput={<ExampleCustomInput />}
                                        dayClassName={() =>
                                          "example-datepicker-day-class"
                                        }
                                        popperClassName="example-datepicker-class"
                                        todayButton="TODAY"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 additional-instructions-col">
                            <div className="card my-2">
                              <div className="card-body">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 p-0">
                                  <div>
                                    <label>Additional Instructions</label>
                                    <textarea
                                      className="form-control"
                                      placeholder="Enter your notes here"
                                      rows="5"
                                      name="additionalInfo"
                                      value={values?.additionalInfo}
                                      onChange={HandleFormChange}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card upload-specification-card mb-2">
                          <div class="card-header">
                            <h2>Upload specification and schedule</h2>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                <div className="table-responsive documents-table-sec">
                                  <AttachmentUpload
                                    values={values}
                                    setValues={setValues}
                                    errors={errors}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
                                <div className="save-btns">
                                  <button className="btn cancel-btn" onClick={handleCancel}>Cancel</button>
                                  <button className="btn save-btn" onClick={handleSubmit} disabled={loading}>{!values?.id ? "Save" : "Update"}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <OrderProduct
                        menuRights={menuRights}
                        values={values}
                        currencyDetail={currencyDetail}
                        setQuotUserEntry={setQuotUserEntry}
                        quotUserEntry={quotUserEntry}
                        setValues={setValues}
                        currencyList={currencyList}
                        handleSubmit={handleSubmit}
                        loading={loading}
                        orderProductTab={orderProductTab}
                        setOrderProductTab={setOrderProductTab}
                        activeMainTab={activeMainTab}

                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- deleteModal--> */}
      <DeleteModal />
      <SaveSuccessModel
        createMsg={createMsg}
        setCreateMsg={setCreateMsg}
        setShow={setShow}
        show={show}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
      {/* <!-- saveSuccessModal--> */}
      <SaveSuccessModel SuccessName="New quotation created successfully" />
    </div>
  );
};

export default AddNewOrder;